import React from "react";
import SvgComponent from "../../../../common/logos/bearLogo";

export default function GraphicIconWrapper({ txt, col }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // background: "pink",
        width: "100%",
        height: "100%",
        marginTop: "-5%",
        marginBottom: "0%",
      }}
    >
      <div>
        <SvgComponent width={"40%"} height={"40%"} col={col} />
      </div>
      <div
        style={{
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10,
        }}
      >
        <h1>{txt}</h1>
      </div>
      {/* <h2><strong>{txt}</strong></h2></div> */}
    </div>
  );
}
